import logoPositive from 'assets/images/logo-home-der.svg'

const Logo = () => (
  <div className='hidden md:flex mt-6 mb-5 2xl:mt-7 2xl:mb-10 justify-center'>
    <img className='w-full md:w-80' src={logoPositive} alt='Waynimóvil' />
  </div>
)

export default Logo
